"use strict";
// @ts-ignore
try {
    self['workbox:cacheable-response:7.4.1'] && _();
}
catch (e) { }
